import styled, { css } from 'styled-components';
import { rgba } from 'polished';

// Import styles
import { flex, customMinResponsive, size, transitionMain } from 'components/styles';

export const CardContainer = styled.div<{ isRecommended: boolean; isCurrent: boolean }>`
	${flex({ fd: 'column', jc: 'space-between' })}
	font-size: 1.6rem;
	gap: 2em;
	padding: 1.75em 1em 1.5em;
	height: 100%;
	position: relative;
	border-radius: 3rem;

	${({ theme, isRecommended }) => css`
		background: linear-gradient(0deg, ${rgba(theme.black, 0.2)}, ${rgba(theme.black, 0.2)}),
			linear-gradient(0deg, ${rgba(theme.white, 0.14)} 0%, ${rgba(theme.white, 0.024)} 53.8%);
		border: 1px solid ${isRecommended ? theme.configurator.color.contrast : rgba(theme.white, 0.18)};
	`};

	${({ isCurrent, theme }) =>
		isCurrent &&
		css`
			background: linear-gradient(0deg, ${rgba(theme.configurator.color.highlight, 0.2)} 0%, ${rgba(theme.configurator.color.highlight, 0.024)} 53.8%),
				linear-gradient(0deg, ${rgba(theme.black, 0.2)}, ${rgba(theme.black, 0.2)});

			border-color: ${theme.configurator.color.highlight};
		`}

	${customMinResponsive(
		450,
		css`
			font-size: 1.7rem;
			padding: 1.75em 1.8em 1.5em;
		`
	)}

	${customMinResponsive(
		1650,
		css`
			font-size: 2rem;
		`
	)}
`;

export const HeaderContainer = styled.div`
	${flex({ fd: 'column', ai: 'flex-start' })}
	width: 100%;
	gap: 1.1em;
	color: ${({ theme: { configurator } }) => rgba(configurator.color.primary, 0.9)};
`;

export const PacketName = styled.p`
	font-weight: ${({ theme: { font } }) => font.semiBold};
	font-size: 1.1em;
	line-height: 1.1em;
	text-align: left;
	margin-top: 1.25rem;
`;

export const ChannelsInfo = styled.button<{ isVisible: boolean }>`
	font-weight: ${({ theme }) => theme.font.light};
	font-size: 1em;
	line-height: 1em;
	min-height: 1em;
	background-color: transparent;
	border: none;
	visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
	text-align: left;
	${transitionMain}

	&:hover:not(:disabled) {
		cursor: pointer;
		color: ${({ theme }) => theme.configurator.color.highlight};
	}
`;

export const Recommendation = styled.p`
	color: ${({ theme }) => theme.configurator.color.contrast};
	font-size: 0.8em;
	font-weight: ${({ theme }) => theme.font.distinct}
	line-height: normal;
	position: absolute;
	z-index: 2;
	top: 0;
	left: 2.3em;
	transform: translateY(-50%);
	padding: 0.75em 1.35em;
	border-radius: 2em;
	border: 1px solid ${({ theme }) => theme.configurator.color.contrast};
	background: ${({ theme }) => theme.configurator.bg.primary};
`;

export const ChannelsPlaceholders = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	row-gap: 0.6em;
	width: 100%;

	${customMinResponsive(
		size.semi,
		css`
			gap: 0.85em;
		`
	)}
`;

export const ChannelPlaceholder = styled.div`
	object-fit: cover;
	width: 29%;
	aspect-ratio: 5 / 3.2;
	border-radius: 0.2em;
	background: ${({ theme }) => theme.configurator.bg.secondary};
`;

export const PriceWrapper = styled.div<{ isAnyPromotion: boolean }>`
	${flex()}
	min-height: ${({ isAnyPromotion }) => (isAnyPromotion ? 6 : 3)}em;
	align-self: flex-start;
	width: 100%;
`;

export const ButtonsWrapper = styled.div`
	width: 100%;
	${flex({ fd: 'column' })}
	row-gap: 1rem;
`;
